/* eslint-disable @typescript-eslint/no-explicit-any */
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'latestInternalNote',
  standalone: false,
})
export class LatestInternalNotePipe implements PipeTransform {
  transform<T>(value: T[] | null | undefined, property?: keyof T): any {
    if (!value || value.length === 0) return null;
    const last = value[value.length - 1];
    return property ? (last as any)[property] : last;
  }
}
